import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function numberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;

    if (value && !/^[0-9]*$/.test(value)) {
      return { mustBeNumber: true };
    }

    return null;
  };
}
